export const SET_YAP_ASSETS = 'app/yapEncrypted/SET_YAP_ASSETS';
export const CLEAR_YAP_ASSETS = 'app/yapEncrypted/CLEAR_YAP_ASSETS';
export const SET_YAP_DEVICE_CONNECTED = 'app/yapEncrypted/SET_YAP_DEVICE_CONNECTED';
export const SET_YAP_HOLDER_CONNECTED = 'app/yapEncrypted/SET_YAP_HOLDER_CONNECTED';
export const SET_YAP_LAST_REQUEST_ID = 'app/yapEncrypted/SET_YAP_LAST_REQUEST_ID';
export const SET_SYNC_LAST_REQUEST_ID = 'app/yapEncrypted/SET_SYNC_LAST_REQUEST_ID';
export const SET_YAP_IS_FORCE_CHECK_REQUEST = 'app/yapEncrypted/SET_YAP_IS_FORCE_CHECK_REQUEST';
export const SET_YAP_SYNC_IN_PROGRESS = 'app/yapEncrypted/SET_YAP_SYNC_IN_PROGRESS';
export const SET_YAP_REQUEST_ACTION_TYPE_DATA = 'app/yapEncrypted/SET_YAP_REQUEST_ACTION_TYPE_DATA';
export const SET_YAP_DEVICE_INFO_RECEIVED = 'app/yapEncrypted/SET_YAP_DEVICE_INFO_RECEIVED';
export const SET_YAP_HOLDER_INFO_RECEIVED = 'app/yapEncrypted/SET_YAP_HOLDER_INFO_RECEIVED';
export const SET_YAP_UPDATE_SETTINGS_IN_PROGRESS = 'app/yapEncrypted/SET_YAP_UPDATE_SETTINGS_IN_PROGRESS';
export const SET_YAP_AUTO_CLEANING_IN_PROGRESS = 'app/yapEncrypted/SET_YAP_AUTO_CLEANING_IN_PROGRESS';
export const SET_YAP_CANCEL_DATA_COLLECTION_IN_PROGRESS = 'app/yapEncrypted/SET_YAP_CANCEL_DATA_COLLECTION_IN_PROGRESS';
export const SET_YAP_DATA_COLLECTION_ALLOWED = 'app/yapEncrypted/SET_YAP_DATA_COLLECTION_ALLOWED';
export const SET_YAP_SYNCRONIZE_DATA_COLLECTION_IN_PROGRESS =
    'app/yapEncrypted/SET_YAP_SYNCRONIZE_DATA_COLLECTION_IN_PROGRESS';
export const ADD_YAP_LAST_DATA_COLLECTION_TIME = 'app/yapEncrypted/ADD_YAP_LAST_DATA_COLLECTION_TIME';
export const VALIDATE_YAP_LAST_DATA_COLLECTION_TIME = 'app/yapEncrypted/VALIDATE_YAP_LAST_DATA_COLLECTION_TIME';
export const SET_YAP_SYNCRONIZE_DEVICE_DATA_COLLECTION_RECEIVED =
    'app/yapEncrypted/SET_YAP_SYNCRONIZE_DEVICE_DATA_COLLECTION_RECEIVED';
export const SET_YAP_SYNCRONIZE_HOLDER_DATA_COLLECTION_RECEIVED =
    'app/yapEncrypted/SET_YAP_SYNCRONIZE_HOLDER_DATA_COLLECTION_RECEIVED';
export const SET_YAP_FIRMWARE_IN_PROGRESS = 'app/yapEncrypted/SET_YAP_FIRMWARE_IN_PROGRESS';
export const SET_OFFLINE_YAP_FIRMWARE_IN_PROGRESS = 'app/yapEncrypted/SET_OFFLINE_YAP_FIRMWARE_IN_PROGRESS';
export const SET_CM_MESSAGE_DATA = 'app/yapEncrypted/SET_CM_MESSAGE_DATA';

const initialData = {
    yapAssets: undefined,
    yapRequestActionTypeData: false,
    yapHolderRequestActionTypeData: false,
    isYapUpdateSettingsInProgress: false,
    isYapAutoCleaningInProgress: false,
    isYapHolderUpdateSettingsInProgress: false,
    isYapDeviceInfoReceived: false,
    isYapHolderInfoReceived: false,
    isYapFirmwareInProgress: false,
    isOfflineYapFirmwareInProgress: false,
    isCancelDataCollectionInProgress: false,
    isYapDeviceConnected: false,
    isYapHolderConnected: false,
    lastRequestId: undefined,
    lastHolderRequestId: undefined,
    lastSyncRequestId: undefined,
    lastHolderSyncRequestId: undefined,
    isYapSyncInProgress: false,
    isYapHolderSyncInProgress: false,
    isYapDataCollectionAllowed: false,
    isYapHolderForceCheckRequest: false,
    isYapForceCheckRequest: false,
    isYapSynchronizeDataCollectionInProgress: false,
    isYapSynchronizeDeviceDataCollectionReceived: false,
    isYapSynchronizeHolderDataCollectionReceived: false,
    cmToken: undefined,
    cmRequestId: undefined,
    lastDataCollectionTimes: [],
};

export default function reducer(state = initialData, action) {
    switch (action.type) {
        case SET_YAP_ASSETS: {
            const stateYapAssets = state.yapAssets;
            const yapAssetsArray = stateYapAssets ? [...stateYapAssets] : [];
            const newAsset = action.payload[0] || {};
            const yapAsset = yapAssetsArray.find((asset) => asset?.isHolder === newAsset.isHolder);

            if (!yapAsset) {
                yapAssetsArray.push(newAsset);
            }

            return {
                ...state,
                yapAssets: yapAssetsArray,
            };
        }
        case CLEAR_YAP_ASSETS: {
            const isHolder = action.payload;
            const yapAssets = isHolder ? state.yapAssets?.filter((x) => x.isHolder !== true) : undefined;

            return {
                ...state,
                yapAssets,
                lastDataCollectionTimes: [],
            };
        }
        case SET_YAP_SYNC_IN_PROGRESS: {
            const {isHolder, data} = action.payload;
            const newData = isHolder ? {isYapHolderSyncInProgress: data} : {isYapSyncInProgress: data};

            return {
                ...state,
                ...newData,
            };
        }
        case SET_SYNC_LAST_REQUEST_ID: {
            const {isHolder, data} = action.payload;
            const newData = isHolder ? {lastHolderSyncRequestId: data} : {lastSyncRequestId: data};

            return {
                ...state,
                ...newData,
            };
        }
        case ADD_YAP_LAST_DATA_COLLECTION_TIME: {
            const lastDataCollectionTimes = state?.lastDataCollectionTimes || [];

            lastDataCollectionTimes.push({time: action.payload || new Date(), isValid: false});
            return {
                ...state,
                lastDataCollectionTimes,
            };
        }
        case VALIDATE_YAP_LAST_DATA_COLLECTION_TIME: {
            const lastDataCollectionTimes = state?.lastDataCollectionTimes || [];

            if (!lastDataCollectionTimes.length) return state;

            const lastDataCollectionTime = lastDataCollectionTimes[lastDataCollectionTimes.length - 1];

            return {
                ...state,
                lastDataCollectionTimes: [{time: lastDataCollectionTime.time, isValid: true}],
            };
        }
        case SET_YAP_UPDATE_SETTINGS_IN_PROGRESS: {
            const {isHolder, data} = action.payload;
            const newData = isHolder
                ? {isYapHolderUpdateSettingsInProgress: data}
                : {isYapUpdateSettingsInProgress: data};

            return {
                ...state,
                ...newData,
            };
        }
        case SET_YAP_CANCEL_DATA_COLLECTION_IN_PROGRESS: {
            return {
                ...state,
                isCancelDataCollectionInProgress: action.payload,
            };
        }
        case SET_YAP_SYNCRONIZE_DATA_COLLECTION_IN_PROGRESS: {
            return {
                ...state,
                isYapSynchronizeDataCollectionInProgress: action.payload,
            };
        }
        case SET_YAP_AUTO_CLEANING_IN_PROGRESS: {
            return {
                ...state,
                isYapAutoCleaningInProgress: action.payload,
            };
        }
        case SET_YAP_DATA_COLLECTION_ALLOWED: {
            return {
                ...state,
                isYapDataCollectionAllowed: action.payload,
            };
        }
        case SET_YAP_SYNCRONIZE_DEVICE_DATA_COLLECTION_RECEIVED: {
            return {
                ...state,
                isYapSynchronizeDeviceDataCollectionReceived: action.payload,
            };
        }
        case SET_YAP_SYNCRONIZE_HOLDER_DATA_COLLECTION_RECEIVED: {
            return {
                ...state,
                isYapSynchronizeHolderDataCollectionReceived: action.payload,
            };
        }
        case SET_YAP_FIRMWARE_IN_PROGRESS: {
            return {
                ...state,
                isYapFirmwareInProgress: action.payload,
            };
        }
        case SET_OFFLINE_YAP_FIRMWARE_IN_PROGRESS: {
            return {
                ...state,
                isOfflineYapFirmwareInProgress: action.payload,
            };
        }
        case SET_YAP_REQUEST_ACTION_TYPE_DATA: {
            const {isHolder, data} = action.payload;
            const newData = isHolder ? {yapHolderRequestActionTypeData: data} : {yapRequestActionTypeData: data};

            return {
                ...state,
                ...newData,
            };
        }
        case SET_YAP_DEVICE_INFO_RECEIVED: {
            return {
                ...state,
                isYapDeviceInfoReceived: action.payload,
            };
        }
        case SET_YAP_HOLDER_INFO_RECEIVED: {
            return {
                ...state,
                isYapHolderInfoReceived: action.payload,
            };
        }
        case SET_YAP_DEVICE_CONNECTED: {
            return {
                ...state,
                isYapDeviceConnected: action.payload,
            };
        }
        case SET_YAP_HOLDER_CONNECTED: {
            return {
                ...state,
                isYapHolderConnected: action.payload,
            };
        }
        case SET_YAP_LAST_REQUEST_ID: {
            const {isHolder, data} = action.payload;
            const newData = isHolder ? {lastHolderRequestId: data} : {lastRequestId: data};

            return {
                ...state,
                ...newData,
            };
        }
        case SET_YAP_IS_FORCE_CHECK_REQUEST: {
            const {isHolder, data} = action.payload;
            const newData = isHolder ? {isYapHolderForceCheckRequest: data} : {isYapForceCheckRequest: data};

            return {
                ...state,
                ...newData,
            };
        }
        case SET_CM_MESSAGE_DATA: {
            return {
                ...state,
                cmToken: action.payload.cmToken,
                cmRequestId: action.payload.cmRequestId,
            };
        }
        default:
            return state;
    }
}

export const setYapAssets = (data) => ({type: SET_YAP_ASSETS, payload: data});

export const clearYapAssets = (isHolder) => ({type: CLEAR_YAP_ASSETS, payload: isHolder});

export const setDeviceInfoReceived = (data) => ({type: SET_YAP_DEVICE_INFO_RECEIVED, payload: data});

export const setHolderInfoReceived = (data) => ({type: SET_YAP_HOLDER_INFO_RECEIVED, payload: data});

export const setYapUpdateSettingsInProgress = (data, isHolder = false) => ({
    type: SET_YAP_UPDATE_SETTINGS_IN_PROGRESS,
    payload: {isHolder, data},
});

export const setYapAutoCleaningInProgress = (data) => ({
    type: SET_YAP_AUTO_CLEANING_IN_PROGRESS,
    payload: data,
});

export const setYapCancelDataCollectionInProgress = (data) => ({
    type: SET_YAP_CANCEL_DATA_COLLECTION_IN_PROGRESS,
    payload: data,
});

export const setYapSynchronizeDataCollectionInProgress = (data) => ({
    type: SET_YAP_SYNCRONIZE_DATA_COLLECTION_IN_PROGRESS,
    payload: data,
});

export const addYapLastDataCollectionTime = (time) => ({
    type: ADD_YAP_LAST_DATA_COLLECTION_TIME,
    payload: time,
});

export const validateYapLastDataCollectionTime = () => ({
    type: VALIDATE_YAP_LAST_DATA_COLLECTION_TIME,
});

export const setIsYapDataCollectionAllowed = (data) => ({
    type: SET_YAP_DATA_COLLECTION_ALLOWED,
    payload: data,
});

export const setYapSynchronizeDeviceDataCollectionReceived = (data) => ({
    type: SET_YAP_SYNCRONIZE_DEVICE_DATA_COLLECTION_RECEIVED,
    payload: data,
});

export const setYapSynchronizeHolderDataCollectionReceived = (data) => ({
    type: SET_YAP_SYNCRONIZE_HOLDER_DATA_COLLECTION_RECEIVED,
    payload: data,
});

export const setYapRequestActionTypeData = ({isHolder, actionType, newValue}) => ({
    type: SET_YAP_REQUEST_ACTION_TYPE_DATA,
    payload: {isHolder, data: {actionType, newValue}},
});

export const setYapFirmwareInProgress = (data) => ({type: SET_YAP_FIRMWARE_IN_PROGRESS, payload: data});

export const setOfflineYapFirmwareInProgress = (data) => ({type: SET_OFFLINE_YAP_FIRMWARE_IN_PROGRESS, payload: data});

export const setYapSyncInProgress = (data, isHolder = false) => ({
    type: SET_YAP_SYNC_IN_PROGRESS,
    payload: {isHolder, data},
});

export const setYapDeviceConnected = (data) => ({type: SET_YAP_DEVICE_CONNECTED, payload: data});

export const setYapHolderConnected = (data) => ({type: SET_YAP_HOLDER_CONNECTED, payload: data});

export const setYapLastRequestId = (data, isHolder = false) => ({
    type: SET_YAP_LAST_REQUEST_ID,
    payload: {isHolder, data},
});

export const setSyncLastRequestId = (data, isHolder = false) => ({
    type: SET_SYNC_LAST_REQUEST_ID,
    payload: {isHolder, data},
});

export const setIsYapForceCheckRequest = (data, isHolder = false) => ({
    type: SET_YAP_IS_FORCE_CHECK_REQUEST,
    payload: {isHolder, data},
});

export const setCmMessageData = (cmToken, cmRequestId) => ({
    type: SET_CM_MESSAGE_DATA,
    payload: {cmToken, cmRequestId},
});
